import { useI18n } from "@/locales/client";
import { KButton } from "@/components/k-button";
import { signIn } from "next-auth/react";

export const DuendeSignIn = ({ provider }: { provider: string }) => {
    const t = useI18n();
    return (
        <KButton
            onClick={() => signIn(provider, { callbackUrl: "/auth/carts" })}
            className="w-full"
            size="lg"
        >
            <div className="flex items-center gap-4">
                {t("SignInWithSanMarco")}
            </div>
        </KButton>
    );
};
